import React from 'react'

import './Grid.css'

const Grid = (props) => {
  const gridStyle = {
    width: `${props.size}px`,
    height: `${props.size}px`,
    gridTemplateColumns: props.data.map(() => '1fr').join(' '),
    gridTemplateRows: props.data.map(() => '1fr').join(' ')
  }

  return (
    <div className={'grid'} style={gridStyle}>
      {
        props.data.map(({row, columns}) => columns.map(({column}) => (
          <div key={row + '-' + column} className={`square`} style={{gridArea: `${row}-${column}`}}></div>
        )))
      }
    </div>
  )
}

export default Grid


// WEBPACK FOOTER //
// ./src/components/Grid.js